import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form, Grid, Message, Segment, Ref, Checkbox } from "semantic-ui-react";
import "./Login.css";
import { Validation } from "./../../utils/UtilMethods";
import * as UtilMethods from "./../../utils/UtilMethods";
import NumPad from "../NumPad/NumPad";
import * as Constants from "../../utils/Constants";

import {
  clearError,
  setError,
  setIsBetaWorkstation,
  setLoadingStatus,
} from "../../lib/store/reducers/applicationStateReducer";
import OperatorEndpoints from "../../lib/operator/OperatorEndpoints";
import { PayloadWrapper } from "../../lib/store/types/PayloadWrapper";
import WorkstationEndpoints from "../../lib/workstation/WorkstationEndpoints";
import SharedFunctions from "../../utils/SharedFunctions";

let { KeyPadKeyCode } = Constants;

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      loginCallback: props.loginCallback,
      input: "",
      loginView: props.loginView || Constants.VIEW.APP,
      loopTeamleader: false,
    };

    this.inputRef = React.createRef();

    this._onInput = this._onInput.bind(this);
    this._login = this._login.bind(this);
    this._onKeyPadInut = this._onKeyPadInut.bind(this);
    this._handleClick = this._handleClick.bind(this);
    this._betaRedirect = this._betaRedirect.bind(this);
  }

  componentDidMount() {
    this._betaRedirect();
  }

  _onInput(e) {
    this.setState({
      input: e.target.value.trim(),
    });
  }
  _onKeyPadInut(val) {
    if (val === KeyPadKeyCode.BACKSPACE && this.state.input.length) {
      this.setState({
        input: this.state.input.substr(0, this.state.input.length - 1),
      });
    } else if ((val || val === KeyPadKeyCode.ZERO) && val !== KeyPadKeyCode.BACKSPACE) {
      this.setState({
        input: this.state.input + val,
      });
    }
  }

  _setInitialURL = () => {
    const path =
      document.location.href.split("?")[0] + `?ws=${UtilMethods.getParamValue("ws")}&review=1`;
    window.history.replaceState({}, document.title, path);
  };

  _redirect = () => {
    let ws = UtilMethods.getParamValue("ws");
    let path = document.location.href.split("?")[0] + `?ws=${ws}&review=1`;
    document.location.href = path;
  };

  _betaRedirect = () => {
    const workstationID = UtilMethods.getParamValue("ws");
    const isBetaWorkstation = document.location.hostname.includes("preprod");
    WorkstationEndpoints.isBetaWorkstation(workstationID)
      .then((res) => {
        let path = "";
        let params = document.location.search.split("?")[1];
        if (res && !isBetaWorkstation) path = Constants.PREPROD_PATH;
        else if (!res && isBetaWorkstation) {
          path = Constants.PROD_PATH;
        } else {
          return;
        }
        this.props.setIsBetaWorkstation(isBetaWorkstation);
        if (process.env.NODE_ENV !== "development") {
          switch (this.state.loginView) {
            case Constants.VIEW.AUTOSTORE:
            case Constants.VIEW.RX:
            case Constants.VIEW.APP:
            case Constants.VIEW.AFRAME:
              SharedFunctions.LogBetaVersionRedirect(res, "packapp", workstationID);
              document.location.href = path + params;
              break;
            case Constants.VIEW.REVIEW:
              if (process.env.NODE_ENV !== "development") {
                SharedFunctions.LogBetaVersionRedirect(res, "reviewapp", workstationID);
                document.location.href = path + `ws=${workstationID}&review=1`;
              } else {
                this._setInitialURL();
              }
              break;
            case Constants.VIEW.VARBERG:
              if (process.env.NODE_ENV !== "development") {
                SharedFunctions.LogBetaVersionRedirect(res, "reviewapp", workstationID);
                document.location.href = path + `ws=${workstationID}&branch=20`;
              } else {
                this._setInitialURL();
              }
              break;
              default:
              break;
          }
        }
      })
      .catch(() => {
        if (this.state.loginView === Constants.VIEW.REVIEW) this._redirect();
      });
  };

  async _login() {
    var input = this.state.input;
    if (Validation.validatePositiveInteger(input)) {
      this.props.toggleLoading(true);

      var companyID = UtilMethods.getParamValue("companyid");
      var branchID = UtilMethods.getParamValue("branchid");

      //let workstationID = this.props.workstationID === -1 ? UtilMethods.getParamValue("ws") : this.props.workstationID;

      if (branchID === -1 || companyID === -1) {
        var errorMessage = "";
        if (branchID === -1 && companyID === -1) {
          errorMessage = "Företag och branch saknas från url.";
          branchID = 12;
          companyID = 1;
        } else if (branchID === -1) {
          errorMessage = "Branch saknas från url.";
          branchID = 12;
        } else {
          errorMessage = "Företag saknas från url.";
          companyID = 1;
        }

        //Slå på när alla shortcuts är uppdaterade
        if (false) {
          this.props.toggleLoading(false);
          return this.setState({
            errorMessage: errorMessage,
          });
        }
      }

      await OperatorEndpoints.login(
        input,
        companyID,
        this.props.workstationID,
        this.state.loginView
      )
        .then((rv) => {
          if (typeof this.state.loginCallback === "function") {
            this.state.loginCallback(rv || input, this.state.loopTeamleader);
            this.props.toggleLoading(false);
          }
        })
        .catch((error) => {
          this._addError(error.message);
          this.setState({
            ...this.state,
            input: "",
          });
          this.props.toggleLoading(false);
        });
    } else {
      this._addError("Felaktigt inmating, förväntades ett operatörsnummer.");
      this.setState({
        ...this.state,
        input: "",
      });
    }
  }

  _handleClick() {
    this._setInputFocus();
  }

  _setInputFocus() {
    this.inputRef && this.inputRef.current && this.inputRef.current.children[0].children[0].focus();
  }

  _addError(message) {
    this.props.setError({
      message,
      visible: true,
      errorType: -1,
    });
    this._setInputFocus();
  }

  _handleLoopTeamleader = (_, data) => {
    console.log(data.checked);
    this.setState({
      loopTeamleader: data.checked,
    });
  };

  render() {
    const rxWest = parseInt(UtilMethods.getParamValue("rxwest")) === 1 ? true : false;
    return (
      <div className="login-form Login" onClick={this._handleClick}>
        <Grid textAlign="center" verticalAlign="middle">
          <Grid.Column>
            <Form size="large" error>
              <Segment>
                <Ref innerRef={this.inputRef}>
                  <Form.Input
                    id="OperatorNumberInput"
                    fluid
                    icon="user"
                    size="massive"
                    placeholder="Operatörsnummer"
                    autoFocus
                    autoComplete="off"
                    loading={this.props.appState.loading}
                    onChange={this._onInput}
                    value={this.state.input}
                  />
                </Ref>
                <Button color="teal" fluid size="huge" onClick={this._login}>
                  Logga in
                </Button>
                {rxWest && (
                  <div className="flexRow flexMiddle loopTeamleader">
                    <span className="teamLeaderLabel">Ansvarig</span>
                    <Checkbox
                      onChange={(_, data) => this._handleLoopTeamleader(_, data)}
                    ></Checkbox>
                  </div>
                )}
              </Segment>
              {this.props.appState.error && (
                <Message error header="" content={this.props.appState.errorMessage} />
              )}
              {!this.props.appState.packingAllowed && (
                <Message
                  error
                  header="Packningen är avstängd."
                  content="Packningen är avstängd på den här stationen."
                />
              )}
              <NumPad onClick={this._onKeyPadInut} />
            </Form>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    appState: state.applicationStateReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleLoading: (loading) => dispatch(setLoadingStatus(new PayloadWrapper(loading))),
    setIsBetaWorkstation: (beta) => dispatch(setIsBetaWorkstation(new PayloadWrapper(beta))),
    setError: (payload) => dispatch(setError(payload)),
    clearError: () => dispatch(clearError()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
